import { render, staticRenderFns } from "./Treasury-Dashboard.vue?vue&type=template&id=8aca7b86&scoped=true"
import script from "./Treasury-Dashboard.vue?vue&type=script&lang=js"
export * from "./Treasury-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Treasury-Dashboard.vue?vue&type=style&index=0&id=8aca7b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca7b86",
  null
  
)

export default component.exports